import jQuery, { get } from "jquery";
window.$ = jQuery;
// import Swiper JS
import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {
    let thumbCarousel = new Swiper(".product-carousel.thumb-carousel .thumb-carousel__thumbnails", {
        slidesPerView: "auto",
        watchSlidesProgress: !0,
        a11y: !0,
    });

    let productCarousel = new Swiper(".product-carousel.thumb-carousel .thumb-carousel__content", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: thumbCarousel,
        },
        a11y: !0,
        keyboard: {
            enabled: !0,
        },
        on: {
            slideChange: function () {
                thumbCarousel.slideTo(productCarousel.activeIndex);
            },
        },
    });

    function R() {
        $(function () {
            let e;
            let t = !1;
            let n = function (t) {
                let n = $(".pdp-nav-list");
                let o = t.position().left - n.position().left;
                let r = t.outerWidth(!0);
                let a = n.innerWidth() - $(".add-cart-button").width();
                let e = n.scrollLeft();
                o < 0 ? n.scrollLeft(e + o) : o + r > a && n.scrollLeft(e + o + r - a);
            };

            function centerActiveLinkOnMobile($link) {
                const $container = $(".pdp-nav-list");
                if ($(window).width() <= 768 && $container.length) {
                    const containerOffset = $container.offset().left;
                    const linkOffset = $link.offset().left;
                    const scrollLeft = $container.scrollLeft();
                    const linkWidth = $link.outerWidth();
                    const containerWidth = $container.outerWidth();
                    const scrollPos = scrollLeft + (linkOffset - containerOffset) - containerWidth / 2 + linkWidth / 2;
                    $container.stop().animate(
                        {
                            scrollLeft: scrollPos,
                        },
                        300
                    );
                }
            }

            let currentHash = "";

            function o() {
                let e = $(document).scrollTop() + 200;
                let found = false;

                $(".pdp-nav-link").each(function () {
                    let t = $(this);
                    let o = $(t.attr("href"));
                    const top = o.position().top;
                    const bottom = top + o.outerHeight();

                    if (top <= e && bottom > e) {
                        $(".pdp-nav-link").removeClass("active").removeAttr("aria-current");
                        t.addClass("active").attr("aria-current", "page");
                        const newHash = t.attr("href");
                        if (newHash !== currentHash) {
                            history.replaceState(null, null, newHash);
                            currentHash = newHash;
                        }
                        centerActiveLinkOnMobile(t);
                        found = true;
                        return false;
                    } else {
                        t.removeClass("active").removeAttr("aria-current");
                    }
                });

                if (!found && currentHash !== "") {
                    $(".pdp-nav-link").removeClass("active").removeAttr("aria-current");
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                    currentHash = "";
                }
            }

            $(document).on("click", ".pdp-nav-link", function () {
                $(document).off("scroll");
                $(".pdp-nav-link").removeClass("active");
                $(this).addClass("active");
                let e = this.hash;
                let t = $(e);
                $(document).off("scroll", o);
                let n = 40;

                if ($(".js-pdp-scroll-value").length > 0) {
                    n = $(".js-pdp-scroll-value").attr("value");
                }

                $("html, body")
                    .stop()
                    .animate(
                        {
                            scrollTop: t.offset().top - n,
                        },
                        500,
                        "swing",
                        function () {
                            history.replaceState(null, null, e);
                            currentHash = e;
                            $(document).on("scroll", o);
                        }
                    );

                centerActiveLinkOnMobile($(this));
            });

            $(window).scroll(function () {
                if ($(".single-tire").length > 0 && !t) {
                    $(document).on("scroll", o);
                    t = true;
                }
            });

            $(".pdp-nav-link").on("focus", function () {
                n($(this));
                centerActiveLinkOnMobile($(this));
            });

            $(window).on("resize", function () {
                const $active = $(".pdp-nav-link.active");
                if ($active.length) {
                    centerActiveLinkOnMobile($active);
                }
            });

            $(window).on("load", function () {
                o();
            });
        });
    }
    R();
});

$(".accordion-open-all").on("click", function () {
    const $accordion = $("#tire-size-accordion");

    const $panels = $accordion.find(".collapse");

    // Check if any panel is hidden
    const anyHidden = $panels.not(".show").length > 0;

    if (anyHidden) {
        $(".accordion-open-all .open-all").toggleClass("d-none");
        $(".accordion-open-all .close-all").toggleClass("d-none");
        // Temporarily remove data-parent to allow multiple panels open
        $panels.each(function () {
            $(this).removeAttr("data-parent");
        });

        // Show all panels
        $panels.collapse("show");

        // Restore data-parent after showing
        $panels.each(function () {
            $(this).attr("data-parent", "#tire-size-accordion");
        });
    } else {
        $(".accordion-open-all .open-all").toggleClass("d-none");
        $(".accordion-open-all .close-all").toggleClass("d-none");
        // Hide all panels normally
        $panels.collapse("hide");
    }
});
